export default {
  namespaced: true,

  state: {
    globalLockCount: 0,
    spMode: false, // windowサイズによる判定(true: smartPhone, false: pc)
    toast: {
      errors: [],
      infos: [],
      show: false,
      timeoutId: '',
    },
    modal: {
      show: false,
      mode: 0, // 0: job, 1: company
      csvTarget: null, // ★追加: 'job' | 'job_list' | 'company' | 'company_list'
      searchJobCsv: null,
    },
    onDownload: false,
  },
  getters: {
    isGlobalLocked: state => !!state.globalLockCount,
    downloading: state => state.modal.show,
    onDownloading: state => state.onDownload,
    modalMode: state => state.modal.mode,
    spMode: state => state.spMode,
    csvTarget: state => state.modal.csvTarget,
    searchJobCsv: state => state.modal.searchJobCsv,
  },
  mutations: {
    lockGlobal: state => state.globalLockCount += 1,
    unlockGlobal: state => state.globalLockCount && (state.globalLockCount -= 1),
    forceUnlockGlobal: state => state.globalLockCount = 0,
    toastErrors: (state, errors) => state.toast.errors = errors,
    toastInfos: (state, info) => state.toast.infos = state.toast.infos.concat(info),
    clearToastInfos: state => state.toast.infos = [],
    hideToast: state => state.toast.show = false,
    showToast: state => state.toast.show = true,
    toastTimeoutId: (state, timeoutId) => state.toast.timeoutId = timeoutId,
    showModal: (state) => {
      state.modal.show = true
      state.onDownload = false
    },
    hideModal: (state) => {
      state.modal.show = false
      state.modal.csvTarget = null
      state.modal.searchJobCsv = null
      state.onDownload = false
    },
    setJobModalMode: (state) => { state.modal.mode = 0; state.onDownload = false },
    setCompanyModalMode: (state) => { state.modal.mode = 1; state.onDownload = false },
    setGroupingJobModalMode: (state) => { state.modal.mode = 2; state.onDownload = false },
    setMapCompanyModalMode: (state) => { state.modal.mode = 3; state.onDownload = false },
    setAggregateJobModalMode: (state) => { state.modal.mode = 4; state.onDownload = false },
    setSearchJobCsvModal: (state, payload) => {
      state.modal.mode = 5
      state.modal.csvTarget = 'job'
      state.modal.searchJobCsv = payload
      state.onDownload = false
    },
    setSpMode: state => state.spMode = true,
    setPcMode: state => state.spMode = false,
    startDownload: state => state.onDownload = true,
    endDownload: state => state.onDownload = false,
    setCsvTarget: (state, target) => { state.modal.csvTarget = target },
  },
  actions: {
    pushToastError ({ commit, state }, { error }) {
      if (state.toast.errors.indexOf(error) !== -1) {
        return
      }
      commit('toastErrors', state.toast.errors.concat(error))
      commit('showToast')
      clearTimeout(state.toast.timeoutId)
      // エラー文言は info より長くなりがちで、503/422 のような深ページ系メッセージは
      // ユーザが読んで理解する時間が必要なため 5 秒に設定する。
      const timeoutId = setTimeout(() => {
        commit('toastErrors', [])
        commit('hideToast')
      }, 5000)
      commit('toastTimeoutId', timeoutId)
    },
    pushToastInfo ({ commit, state }, { info }) {
      commit('toastInfos', info)
      commit('showToast')
      clearTimeout(state.toast.timeoutId)
      const timeoutId = setTimeout(() => {
        commit('clearToastInfos')
        commit('hideToast')
      }, 3000)
      commit('toastTimeoutId', timeoutId)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js